import axios from 'axios';
import _ from 'lodash';

const GET_FEATURE_FLAGS_SUCCESS = 'GET_FEATURE_FLAGS_SUCCESS';
const ERROR = 'ERROR';

export const defaultState = {
    featureFlags: {},
};

const reducer = (state = _.cloneDeep(defaultState), action) => {
    switch (action.type) {
        case GET_FEATURE_FLAGS_SUCCESS:
            return {...state, featureFlags: action.features};       
        case ERROR:
        default:
            return state;
    }
}

export function getFeatureFlags() {
    return (dispatch, getState) => {
        return axios
            .get('/setting/features')
            .then(({data: features}) => dispatch({type: GET_FEATURE_FLAGS_SUCCESS, features}))
            .catch(_.noop);

    };
}

export default reducer;
